import React from "react";
import CloseIcon from "material-ui/svg-icons/navigation/close";
import IconButton from "@material-ui/core/IconButton";
import { Link } from "react-router-dom";
import {
  getImagePreviewUrl,
  getFilePreviewUrl
} from "../../services/FileStackService";

import Dialog from "material-ui/Dialog";

class ChecklistCreator extends React.Component {
  state = {
    isOpen: false
  };

  onClose = () => {
    this.setState({ isOpen: false });
  };

  getUri = isFile => {
    return !isFile ? getImagePreviewUrl : getFilePreviewUrl;
  };

  render() {
    const { isOpen } = this.state;
    const { list, title } = this.props;

    return (
      <React.Fragment>
        <Dialog
          onRequestClose={this.onClose}
          open={isOpen}
          autoDetectWindowHeight
          autoScrollBodyContent
        >
          <div style={{ width: "100%" }}>
            <h3>{`You have ${list.length} ${title}`}</h3>
            <IconButton
              aria-label="Close"
              style={{
                position: "absolute",
                right: "25px",
                top: "25px",
                color: "#dedede"
              }}
              onClick={this.onClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          {list.map(({ id, projectId, isFile, filestackId }) => {

            return (
              <Link
                key={id}
                to={`/details/${projectId}/${id}`}
                style={{ marginRight: "15px", marginBottom: "15px" }}
                target="_blank"
              >
                <img
                  className="img-issue loading"
                  src={this.getUri(isFile)(filestackId, 200, 200)}
                  alt=""
                  width="200"
                  height="200"
                />
              </Link>
            );
          })}
        </Dialog>

        {list.length > 0 && (
          <span
            style={{ color: "#0645AD" }}
            onClick={(e) => {
              e.stopPropagation();
              this.setState({ isOpen: true });
            }}
          >
            {title}
          </span>
        )}
      </React.Fragment>
    );
  }
}

export default ChecklistCreator;
